import { parseBoolean } from '../utils/parsers';

type Environment = 'development' | 'production' | 'staging';

export interface EnvironmentConfig {
  apiUrl: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  environment: Environment;
  enableLogging: boolean;
  bypassPermissions: boolean;
  debugMode: boolean;
  enableQueryDevtools: boolean;
}

export const environment: EnvironmentConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'https://jsonplaceholder.typicode.com',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  environment: (import.meta.env.VITE_ENVIRONMENT as Environment) ?? 'development',
  enableLogging: parseBoolean(import.meta.env.VITE_ENABLE_LOGGING, true),
  bypassPermissions: parseBoolean(import.meta.env.VITE_BYPASS_PERMISSIONS),
  debugMode: parseBoolean(import.meta.env.VITE_DEBUG_MODE),
  enableQueryDevtools: parseBoolean(import.meta.env.VITE_ENABLE_QUERY_DEVTOOLS, true),
};

// Helpers
export const isDevelopment = () => environment.environment === 'development';
export const isProduction = () => environment.environment === 'production';
export const isStaging = () => environment.environment === 'staging';
export const shouldBypassPermissions = () => environment.bypassPermissions;
export const isDebugMode = () => environment.debugMode;
